export function bar(ctx) {
    return {
        styles: {
            main:      { ...ctx.pretty, radius: 999 },
            indicator: { bg_color: '#ffffff' },
        },
    };
}
